// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/background.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  margin: 0;
  padding: 0;
  min-height: 100vh;
}

.file-upload-container {
  padding: 24px;
  max-width: 1400px;
  margin: 0 auto;
  min-height: 100vh;
}

.file-upload-card {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
}

.file-upload-title-container {
  text-align: center;
}

.top-left-header {
  height: 40px;
  margin-top: 16px;
  margin-bottom: 8px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.file-upload-logo {
  height: 48px;
  width: auto;
  color: black;
  margin: 24px 0;
}

.file-upload-subtitle {
  padding-top:20px;
  margin: 12px 0;
  display: inline-block;
}

.file-upload-dropzone {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}

.file-upload-dropzone .ant-upload-drag {
  flex: 1 1;
}

.file-upload-content {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.file-upload-button {
  max-width: 200px;
  width: 100%;
  margin: 0 auto;
}

.no-data-logo {
  height: 48px;
  width: auto;
}`, "",{"version":3,"sources":["webpack://./src/components/FileUpload.css"],"names":[],"mappings":"AAAA;EACE,yDAAgD;EAChD,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;EAC5B,SAAS;EACT,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb","sourcesContent":["body {\n  background-image: url('/public/background.webp');\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-attachment: fixed;\n  margin: 0;\n  padding: 0;\n  min-height: 100vh;\n}\n\n.file-upload-container {\n  padding: 24px;\n  max-width: 1400px;\n  margin: 0 auto;\n  min-height: 100vh;\n}\n\n.file-upload-card {\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  border-radius: 8px;\n}\n\n.file-upload-title-container {\n  text-align: center;\n}\n\n.top-left-header {\n  height: 40px;\n  margin-top: 16px;\n  margin-bottom: 8px;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.file-upload-logo {\n  height: 48px;\n  width: auto;\n  color: black;\n  margin: 24px 0;\n}\n\n.file-upload-subtitle {\n  padding-top:20px;\n  margin: 12px 0;\n  display: inline-block;\n}\n\n.file-upload-dropzone {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.file-upload-dropzone .ant-upload-drag {\n  flex: 1;\n}\n\n.file-upload-content {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.file-upload-button {\n  max-width: 200px;\n  width: 100%;\n  margin: 0 auto;\n}\n\n.no-data-logo {\n  height: 48px;\n  width: auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
